<template>
  <v-dialog
    :value="isInfoDialogOpen"
    max-width="700px"
    persistent
  >
    <v-card class="pa-4">
      <btn-close-dialog :handle-click="closeDialog"></btn-close-dialog>

      <v-card-title class="justify-center text-h5">
        Criar formulário
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formularioData.nome"
                outlined
                dense
                :rules="[validators.required]"
                label="Nome"
                placeholder="Nome"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="formularioData.descricao"
                outlined
                dense
                auto-grow
                label="Descrição"
                placeholder="Descrição"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                color="primary"
                class="mr-3"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-3"
                  indeterminate
                  color="secundary"
                ></v-progress-circular>
                <span v-else>Criar</span>
              </v-btn>
              <v-btn
                color="secondary"
                class="mb-1"
                outlined
                type="reset"
                @click="resetFormAndCloseDialog"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from '@core/utils/validation'
import { mdiClose } from '@mdi/js'
import { ref, reactive } from '@vue/composition-api'
import Vue from 'vue'
import { useRouter } from '@/@core/utils'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    BtnCloseDialog,
  },

  props: {
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
  },

  setup(_, { emit }) {
    const { router } = useRouter()

    const formularioData = reactive({
      nome: '',
      descricao: '',
      ativo: true,
    })

    const form = ref(null)
    const valid = ref(false)
    const loading = ref(false)

    const resetForm = () => {
      form.value.reset()
    }
    const closeDialog = () => emit('update:is-info-dialog-open', false)
    const resetFormAndCloseDialog = () => {
      resetForm()
      closeDialog()
    }

    const successCallback = res => {
      setTimeout(() => {
        loading.value = false
      }, 1000)
      router.push(`formulario/${res.data.data.id}`)
    }
    const failureCallback = () => {
      loading.value = false
    }

    const handleSubmit = () => {
      if (loading.value) return

      loading.value = true
      if (valid.value) {
        try {
          FormularioService.criar(formularioData)
          successCallback()
          closeDialog()
        } catch {
          failureCallback()
        }
      } else {
        loading.value = false
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    return {
      formularioData,
      form,
      valid,
      loading,
      closeDialog,
      resetFormAndCloseDialog,
      handleSubmit,
      validators: {
        required,
      },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
